export var HistoricalCurveTimeRange;
(function (HistoricalCurveTimeRange) {
    /**
     * 全开区间
     */
    HistoricalCurveTimeRange[HistoricalCurveTimeRange["BeginOpenEndOpen"] = 0] = "BeginOpenEndOpen";
    /**
     * 左开右闭
     */
    HistoricalCurveTimeRange[HistoricalCurveTimeRange["BeginOpenEndClose"] = 1] = "BeginOpenEndClose";
    /**
     * 左闭右开
     */
    HistoricalCurveTimeRange[HistoricalCurveTimeRange["BeginCloseEndOpen"] = 2] = "BeginCloseEndOpen";
    /**
     * 全闭区间
     */
    HistoricalCurveTimeRange[HistoricalCurveTimeRange["BeginCloseEndClose"] = 3] = "BeginCloseEndClose";
})(HistoricalCurveTimeRange || (HistoricalCurveTimeRange = {}));
